(() => {
  const config = window.ADVENT_RESERVATION_CONFIG;
  if (!config || !config.forms[config.market]) return;
  const market = config.market;
  let stock = config.stock || {};
  let stockReadAt = Date.now(), pending = null, openTimer;
  const copy = market === "dk" ? {reserve:"Reservér i 48 timer",wait:"Få besked hvis flere kommer",opening:"Åbner …",failed:"Formularen kunne ikke åbnes. Prøv igen, og kontrollér dit valg af marketingcookies."} : {reserve:"48 Stunden reservieren",wait:"Benachrichtigen, wenn wieder verfügbar",opening:"Wird geöffnet …",failed:"Das Formular konnte nicht geöffnet werden. Bitte versuche es erneut und prüfe deine Auswahl für Marketing-Cookies."};
  const ready = color => Number.isInteger(stock[color]?.available) && stock[color].available > 0;
  const known = color => Number.isInteger(stock[color]?.available);
  const label = color => known(color) ? (ready(color) ? copy.reserve : copy.wait) : (market === "dk" ? "Se tilgængelighed" : "Verfügbarkeit prüfen");
  const markup = color => `<button type="button" class="advent-reservation-cta" data-advent-reserve="${color}">${label(color)}</button><p class="advent-reservation-status" role="status" aria-live="polite" hidden></p>`;
  function refreshControls() {
    document.querySelectorAll("[data-advent-reserve]").forEach(button => {
      const text = label(button.dataset.adventReserve);
      if (!button.disabled && button.textContent !== text) button.textContent = text;
    });
  }
  async function freshStock() {
    // This JSON view belongs to a product template, including when reserving
    // from the landing page or the destination experiment's inline product.
    const url = new URL('/products/adventskalender-2026-gold-dk-test', location.origin);
    url.searchParams.set("view", "advent-reservation-stock");
    url.searchParams.set("_", Date.now());
    const preview = new URL(location.href).searchParams.get("preview_theme_id");
    if (preview) url.searchParams.set("preview_theme_id", preview);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 1800);
    let response;
    try { response = await fetch(url, {cache:"no-store", signal:controller.signal}); }
    finally { clearTimeout(timeout); }
    if (!response.ok) throw new Error("Stock unavailable");
    stock = await response.json(); stockReadAt = Date.now();
    refreshControls();
  }
  function reservationDialog(color, button) {
    const dk = market === 'dk';
    const dialog = document.createElement('dialog');
    dialog.className = 'advent-reserve-dialog';
    dialog.setAttribute('aria-labelledby','advent-reserve-title');
    dialog.innerHTML = `<button type="button" class="advent-reserve-close" aria-label="${dk?'Luk':'Schließen'}">×</button><img class="advent-reserve-image" src="https://cdn.shopify.com/s/files/1/0843/0885/3078/files/advent-v2-packaging-black.webp?v=1791231373" width="2200" height="1467" alt="${dk?'Lelafines adventsæske med fire smykkeæsker':'Lelafine Adventsbox mit vier Schmuckboxen'}"><div class="advent-reserve-content"><h2 id="advent-reserve-title">${dk?'Reserver din kalender':'Kalender reservieren'}</h2><p class="advent-reserve-intro">${dk?'Din kalender, lagt til side i 48 timer.<br>Få dit link på mail.':'Dein Kalender, 48 Stunden für dich zurückgelegt.<br>Dein Link kommt per E-Mail.'}</p><form><input id="advent-reserve-email" name="email" type="email" autocomplete="email" aria-label="E-mail" placeholder="${dk?'Din e-mailadresse':'Deine E-Mail-Adresse'}" required maxlength="254"><p class="advent-reserve-consent" id="advent-reserve-consent"><span>${dk?'Du får reservationsmails og nyhedsbrev. Afmeld når som helst.':'Du erhältst Reservierungs-E-Mails und unseren Newsletter. Jederzeit abmeldbar.'}</span> <a href="/policies/privacy-policy" target="_blank" rel="noopener">${dk?'Privatliv':'Datenschutz'}</a></p><button type="submit" class="primary" aria-describedby="advent-reserve-consent">${dk?'Reserver din kalender':'Kalender reservieren'}</button><p role="status" aria-live="polite" hidden></p></form></div>`;
    document.body.append(dialog);
    const form = dialog.querySelector('form'), status = form.querySelector('[role=status]'), submit = form.querySelector('[type=submit]');
    let sending = false;
    dialog.querySelector('.advent-reserve-close').onclick = () => { if (!sending) dialog.close(); };
    dialog.addEventListener('cancel', event => { if (sending) event.preventDefault(); });
    dialog.addEventListener('close', () => {
      window.ADVENT_RESERVATION_POPUP_OPEN = false; pending = null;
      dialog.remove(); if (button?.isConnected) button.focus();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (sending || !form.reportValidity()) return;
      sending = true; submit.disabled = true; status.hidden = false;
      status.textContent = dk?'Sender …':'Wird gesendet …';
      try {
        await freshStock();
        if (!ready(color)) throw new Error('stock');
        const email = form.elements.email.value.trim(), now = new Date().toISOString();
        const properties = {
          advent_reservation_submitted_at:now, advent_reservation_color:color,
          advent_reservation_market:market.toUpperCase(), advent_reservation_form_id:config.forms[market][color],
          [`advent_${market}_reservation_submitted_at`]:now,
          [`advent_${market}_reservation_form_id`]:config.forms[market][color],
          advent_reservation_consent_text:form.querySelector('.advent-reserve-consent span').textContent,
          advent_reservation_consent_method:'submit_button',
          ...window.AdventAttribution?.properties?.()
        };
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V9j95P', {
          method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},
          body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:`Advent reservation ${market} ${color}`,profile:{data:{type:'profile',attributes:{email,properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:market==='dk'?'XJgR7n':'WVZhMX'}}}}})
        });
        if (!response.ok) throw new Error('subscription');
        // List-triggered flows enter once per profile: retrying cannot send a second pair.
        dialog.querySelector('#advent-reserve-title').textContent = dk?'Tak for din reservation':'Danke für deine Reservierung';
        dialog.querySelector('.advent-reserve-intro').textContent = dk?'Dit link kommer på mail. Kig i din indbakke.':'Dein Link kommt per E-Mail. Schau in dein Postfach.';
        form.hidden = true;
        try { localStorage.setItem('lelafine:advent:opened','1'); } catch {}
      } catch (error) {
        status.textContent = error.message==='stock' ? (dk?'Kalenderen kan ikke reserveres lige nu. Luk vinduet for at se den aktuelle tilgængelighed.':'Der Kalender kann gerade nicht reserviert werden. Schließe das Fenster, um die aktuelle Verfügbarkeit zu sehen.') : (dk?'Reservationen kunne ikke bekræftes. Prøv igen.':'Die Reservierung konnte nicht bestätigt werden. Bitte versuche es erneut.');
        submit.disabled = false;
      } finally { sending = false; }
    });
    dialog.showModal(); dialog.querySelector('input[type=email]').focus();
  }

  async function open(color, button = null) {
    if (color === "landing") color = "gold";
    if (pending || window.ADVENT_RESERVATION_POPUP_OPEN) return;
    pending = {button, form:null};
    const status = button?.nextElementSibling;
    if (button) { button.disabled = true; button.textContent = copy.opening; button.setAttribute("aria-busy","true"); }
    if (status) status.hidden = true;
    // Liquid is the first component read. Refresh older reads without a silent five-second wait.
    if (!known(color) || Date.now() - stockReadAt > 30000) {
      try {
        await freshStock();
        if (!known(color)) throw new Error("Stock unavailable");
      } catch {
        if (button) { button.disabled = false; button.removeAttribute("aria-busy"); }
        if (status) { status.textContent = market === "dk" ? "Lagerstatus kunne ikke hentes. Prøv igen." : "Die Verfügbarkeit konnte nicht geladen werden. Bitte versuche es erneut."; status.hidden = false; }
        pending = null; refreshControls(); return;
      }
    }
    if (ready(color)) {
      if (button) { button.disabled = false; button.removeAttribute("aria-busy"); }
      window.ADVENT_RESERVATION_POPUP_OPEN = true;
      reservationDialog(color, button); refreshControls(); return;
    }
    const form = ready(color) ? config.forms[market][color] : config.waitlist[market];
    pending.form = form;
    window.ADVENT_RESERVATION_POPUP_OPEN = true;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", form]);
    openTimer = setTimeout(() => {
      window.ADVENT_RESERVATION_POPUP_OPEN = false;
      if (button) { button.disabled = false; button.removeAttribute("aria-busy"); }
      if (status) { status.textContent = copy.failed; status.hidden = false; }
      pending = null; refreshControls();
    }, 8000);
  }
  document.addEventListener("click", event => {
    const button = event.target.closest("[data-advent-reserve]");
    if (!button || button.disabled) return;
    event.preventDefault();
    open(button.dataset.adventReserve, button);
  }, true);
  window.addEventListener("klaviyoForms", event => {
    const id = event.detail?.formId || event.detail?.formID;
    if (![...Object.values(config.forms[market]),config.waitlist[market]].includes(id)) return;
    if (event.detail.type === "open") {
      clearTimeout(openTimer);
      if (pending?.button) { pending.button.disabled = false; pending.button.removeAttribute("aria-busy"); }
      pending = null; refreshControls();
      try { localStorage.setItem("lelafine:advent:opened","1"); } catch {}
      window.ADVENT_RESERVATION_POPUP_OPEN = true;
    } else if (["close","redirectedToUrl"].includes(event.detail.type)) window.ADVENT_RESERVATION_POPUP_OPEN = false;
    if (!Object.values(config.forms[market]).includes(id)) return;
    if (event.detail.type !== "submit") return;
    const email = event.detail.metaData?.email || event.detail.metaData?.$email;
    if (!email || !window.klaviyo) return;
    const time = new Date().toISOString();
    const color = id === config.forms[market].gold ? "gold" : "silver";
    const source = `advent-reservation-${market}-${color}`;
    window.klaviyo.identify({email,advent_reservation_consent_at:time,advent_reservation_source:source,advent_reservation_consent_text:market === "dk" ? "Du får reservationslink og nyhedsbrev. Afmeld når som helst." : "Du erhältst deinen Reservierungslink und unseren Newsletter. Jederzeit abmeldbar."}).then(() =>
      window.klaviyo.track(`Advent reservation ${market.toUpperCase()} mail 1`, {
        reservation_submitted_at:time,form_id:id,market:market.toUpperCase(),color,source,
        consent_text:market === "dk" ? "Du får reservationslink og nyhedsbrev. Afmeld når som helst." : "Du erhältst deinen Reservierungslink und unseren Newsletter. Jederzeit abmeldbar."
      })
    );
  });
  function automatic(selectColor) {
    let consentAt = null, scrollInputAt = 0, attempted = false;
    const visible = () => {
      if (document.documentElement.classList.contains("lelafine-consent-pending")) return true;
      const dialog = document.querySelector("pandectes-cmp")?.shadowRoot?.querySelector("dialog[open],.dialog.notice[open],.dialog.notice:not([hidden])");
      if (!dialog) return false;
      const rect = dialog.getBoundingClientRect(), style = getComputedStyle(dialog);
      return rect.width > 1 && rect.height > 1 && style.display !== "none" && style.visibility !== "hidden" && Number(style.opacity || 1) > .05;
    };
    function evaluate() {
      if (attempted || document.hidden || visible() || window.Shopify?.customerPrivacy?.marketingAllowed?.() !== true) return;
      if (consentAt === null) consentAt = Date.now();
      const scrollable = document.documentElement.scrollHeight - innerHeight;
      const scrolled = Date.now() - scrollInputAt < 1200 && scrollable > 0 && scrollY / scrollable >= .25;
      if (Date.now() - consentAt < 15000 && !scrolled) return;
      const source = new URLSearchParams(location.search).get("utm_source") || "";
      if (/onskeskyen|gowish/i.test(source)) return;
      try { if (["lelafine:advent:opened","lelafine:welcome-offer:opened","advent-v2-popup-seen","advent-dk-v2-popup-seen"].some(key => localStorage.getItem(key))) return; } catch { return; }
      const color = selectColor(); if (!color || pending || window.ADVENT_RESERVATION_POPUP_OPEN) return;
      const claim = async () => {
        try { if (localStorage.getItem("lelafine:advent:opened")) return; localStorage.setItem("lelafine:advent:opened","1"); } catch { return; }
        attempted = true; await open(color);
      };
      if (navigator.locks) navigator.locks.request("lelafine:advent:automatic",claim);
    }
    for (const name of ["wheel","touchmove","keydown"]) addEventListener(name,event => { if (event.isTrusted && (name !== "keydown" || ["ArrowDown","PageDown","End"," "].includes(event.key))) scrollInputAt = Date.now(); },{passive:true});
    addEventListener("scroll",evaluate,{passive:true});
    document.addEventListener("visitorConsentCollected",evaluate);
    setInterval(evaluate,250); evaluate();
  }
  window.AdventReservation = {markup,refreshControls,automatic};
  document.addEventListener("DOMContentLoaded", refreshControls);
  setInterval(() => { if (!document.hidden) freshStock().catch(() => { /* Keep the last confirmed label; opening and submitting refresh stale stock. */ }); }, 30000);
})();
